(function () {
  'use strict'

  /**
   * @ngdoc directive
   * @name thismomentGlowModuleHeader
   * @module thismoment.glow.component.module.header
   *
   * @description
   * The header module for glow
   *
   * @example <pre><code>&#x3C;thismoment-glow-header id=&#x22;1&#x22;&#x3E;&#x3C;/thismoment-glow-header&#x3E;</code></pre>
   */

  require('./scss/module-header.scss')

  var MODULE_NAME = 'thismoment.glow.component.module.header'
  var templateUrl = require('./tpl/module-header.html')

  angular
    .module(MODULE_NAME, [
      require('../../../../common/factory/sharing-links')
    ])
    .component('thismomentGlowModuleHeader', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        pageTitle: '<',
        moduleId: '<',
        name: '<',
        backgroundColor: '<',
        backgroundImage: '<',
        backgroundImageAltText: '<',
        backgroundImagePosition: '<',
        brandingImage: '<',
        brandingImageAltText: '<',
        brandingImagePosition: '<',
        enableFacebookSharing: '<',
        enableGoogleplusSharing: '<',
        enableTwitterSharing: '<',
        socialIconsPosition: '<',
        margin: '<',
        mobileBackgroundColor: '<',
        mobileBackgroundImage: '<',
        mobileBackgroundImageAltText: '<',
        mobileBackgroundImagePosition: '<',
        mobileBrandingImage: '<',
        mobileBrandingImageAltText: '<',
        mobileBrandingImagePosition: '<',
        mobileMargin: '<',
        isFixed: '<'
      },
      controller: glowHeaderController
    })

  glowHeaderController.$inject = ['$scope', '$location', 'SdkConfig', 'analyticsSDK', 'SharingLinks']
  function glowHeaderController ($scope, $location, SdkConfig, analyticsSDK, SharingLinks) {
    var vm = this

    vm.styles = vm.classes = {}

    vm.$onInit = headerInit

    $scope.$on('breakpoint:resize', function (event) {
      headerInit()
      $scope.$apply()
    })

    function headerInit () {
      setResponsiveOptions()

      vm.showSocialSharing = (
        vm.enableFacebookSharing ||
                vm.enableGoogleplusSharing ||
                vm.enableTwitterSharing
      )

      if (vm.showSocialSharing) {
        switch (vm.socialIconsPosition) {
          case 'center':
            vm.styles.social_icons = {
              'transform': 'translateX(-50%)',
              'left': '50%'
            }
            break

          case 'right':
            vm.styles.social_icons = {
              'right': 0
            }
            break
        }

        if (vm.enableFacebookSharing) {
          vm.showFacebookShare = true
          vm.facebookShareLink = SharingLinks.create('facebook', {
            url: $location.absUrl()
          })
        }

        if (vm.enableGoogleplusSharing) {
          vm.showGoogleplusShare = true
          vm.googleplusShareLink = SharingLinks.create('googleplus', {
            url: $location.absUrl()
          })
        }

        if (vm.enableTwitterSharing) {
          vm.showTwitterShare = true
          vm.twitterShareLink = SharingLinks.create('twitter', {
            title: vm.pageTitle,
            url: $location.absUrl()
          })
        }
      }

      vm.trackShare = trackShare
    }

    function trackShare (service) {
      vm.trackEvent({
        action: 'Module Shared',
        properties: {
          'event trigger': 'clicked ' + service + ' share button'
        }
      })
    }

    function setResponsiveOptions () {
      var backgroundColor
      var backgroundImage
      var brandingImage
      var brandingImagePosition
      var margin

      switch (SdkConfig.get('breakpoint')) {
        case 'xs':
        case 'sm':
          // styles
          backgroundColor = vm.mobileBackgroundColor || vm.backgroundColor
          backgroundImage = vm.mobileBackgroundImage || vm.backgroundImage
          brandingImage = vm.mobileBrandingImage || vm.brandingImage
          brandingImagePosition = vm.mobileBrandingImagePosition || vm.brandingImagePosition
          margin = vm.mobileMargin || vm.margin

          // accessibility
          vm.brandingAltText = vm.mobileBrandingImageAltText || vm.brandingImageAltText
          vm.backgroundAltText = vm.mobileBackgroundImageAltText || vm.backgroundImageAltText
          break

        case 'md':
        case 'lg':
          // styles
          backgroundColor = vm.backgroundColor
          backgroundImage = vm.backgroundImage
          brandingImage = vm.brandingImage
          brandingImagePosition = vm.brandingImagePosition
          margin = vm.margin

          // accessibility
          vm.brandingAltText = vm.brandingImageAltText
          vm.backgroundAltText = vm.backgroundImageAltText
          break
      }

      vm.styles = {
        wrapper: {
          'background-color': backgroundColor,
          'margin': margin
        }
      }

      if (brandingImage) {
        vm.brandingImageSrc = brandingImage.url
        switch (brandingImagePosition) {
          case 'center':
            vm.styles.branding_image = {
              'transform': 'translateX(-50%)',
              'left': '50%'
            }
            break

          case 'right':
            vm.styles.branding_image = {
              'right': 0
            }
            break
        }
      }

      if (backgroundImage) {
        vm.backgroundImageSrc = backgroundImage.url
        angular.merge(vm.styles.wrapper, {
          'height': 0,
          'padding-top': ((backgroundImage.height) / backgroundImage.width) * 100 + '%'
        })
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-header/index.js